module.exports = __webpack_public_path__ + "static/media/euroIcon.a1a1de32.svg";